/**
 * THE H frontend entry.
 * - 부트스트랩: Application 클래스 (공통 + 라우트 디스패치).
 * - 레이아웃: layouts/main.php 의 data-controller / data-action, data-site-text-motion.
 */
import { Application } from "./Application";
// /templates 컴포넌트 init 을 공개 app.js 에 통합(별도 template-components.js 제거).
// import 시점에 컴포넌트 index.js 가 self-register; initTemplateComponents()는 재초기화 훅.
import { initTemplateComponents } from "./template";

function boot(): void {
    // 새로고침 시 항상 최상단에서 시작 — hero ScrollTrigger progress 가 1 로 복원되어
    // 헤드라인이 yPercent:-100 으로 고정되는 버그 방지. 실제 스크롤 0 동기화는
    // SmoothScrollManager(Lenis) 가 manual 가드 아래에서 담당.
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }
    new Application().boot();
    initTemplateComponents();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
} else {
    boot();
}
